import { render, staticRenderFns } from "./ScriptInput.vue?vue&type=template&id=36f0a6c9&scoped=true&"
import script from "./ScriptInput.vue?vue&type=script&lang=js&"
export * from "./ScriptInput.vue?vue&type=script&lang=js&"
import style0 from "./ScriptInput.vue?vue&type=style&index=0&id=36f0a6c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f0a6c9",
  null
  
)

export default component.exports